import React, { useState } from "react";
import PropTypes from "prop-types";

// campo de senha com botão para exibir/ocultar o texto digitado
const SenhaInput = ({ iconeEsquerda, className, ...props }) => {
  const [visivel, setVisivel] = useState(false);

  return (
    <div className={`ui icon input senha-input ${iconeEsquerda ? "left" : ""} ${className || ""}`}>
      {iconeEsquerda && <i className={`${iconeEsquerda} icon`} aria-hidden="true" />}
      <input {...props} type={visivel ? "text" : "password"} />
      <i
        role="button"
        tabIndex={0}
        aria-label={visivel ? "Ocultar senha" : "Exibir senha"}
        title={visivel ? "Ocultar senha" : "Exibir senha"}
        className={`${visivel ? "eye slash" : "eye"} link icon senha-input-toggle`}
        onClick={() => setVisivel(v => !v)}
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setVisivel(v => !v);
          }
        }}
      />
    </div>
  );
};

SenhaInput.propTypes = {
  iconeEsquerda: PropTypes.string,
  className: PropTypes.string
};

export default SenhaInput;
